export default "__VITE_ASSET__DVj4l1Wh__"